import React from 'react'
import { Link } from 'react-router-dom'
import ProductList from './ProductList'
import Cart from './Cart'
import { useSelector } from 'react-redux'

const Navbar = () => {
  const cartItems=useSelector(state=>state.cart.items)
  return (
    <nav>
      <h1>Shopping Cart</h1>
      <div>
      <Link to='/' element={<ProductList/>}>Home</Link>
      <Link to='/cart' element={<Cart/>}>Cart({cartItems.length})</Link>
      </div>
    </nav>
  )
}

export default Navbar
